export default {
    SET_GROUPS_OF_CUSTOMER(state, groupsOfCustomer) {
        state.groupsOfCustomer = groupsOfCustomer
    },
    SET_GROUPS_OF_CUSTOMER_RESUME(state, groupsOfCustomerResume) {
        state.groupsOfCustomerResume = groupsOfCustomerResume
    },
    SET_GROUP_OF_CUSTOMER_INFOS(state, groupOfCustomerInfos) {
        state.groupOfCustomerInfos = groupOfCustomerInfos
    },
    ADD_GROUP_OF_CUSTOMER(state, groupOfCustomer) {
        const groupOfCustomerIndex = state.groupsOfCustomer.items.findIndex((g) => g.id === groupOfCustomer.id)
        if (groupOfCustomerIndex === -1) { state.groupsOfCustomer.items.unshift(groupOfCustomer) }
    },
    UPDATE_GROUP_OF_CUSTOMER(state, groupOfCustomer) {
        const groupOfCustomerIndex = state.groupsOfCustomer.items.findIndex((g) => g.id === groupOfCustomer.id)
        if (groupOfCustomerIndex === -1) {
            state.groupsOfCustomer.items.unshift(groupOfCustomer)
        } else {
            Object.assign(state.groupsOfCustomer.items[groupOfCustomerIndex], groupOfCustomer)
        }
    },
    DELETE_GROUP_OF_CUSTOMER(state, groupOfCustomerId) {
        const ItemIndex = state.groupsOfCustomer.items.findIndex((g) => g.id === groupOfCustomerId)
        state.groupsOfCustomer.items.splice(ItemIndex, 1)
    }
}
